import React, { useState, useEffect } from 'react';
import { Input, Label, Row, Col, } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';

//Funciones
import { apiExportarInformeFinalMOC, apiExportarInformeFinalMONC } from '../../../utils/APIs/APISResume';

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalProcesoAprobado = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [fecha, setFecha] = useState(new Date(Date.now()));//Aprendizaje// "fecha": "2020-01-01",
    const [nombre, setNombre] = useState(undefined);
    const [cargo, setCargo] = useState(props.dataAPE.codigoCargo ?? undefined);
    const [aspirante, setAspirante] = useState('ASPIRANTE');
    const [experienciaRequerida, setExperienciaReq] = useState(undefined);
    const [experienciaActual, setExperienciaAct] = useState(undefined);
    const [formacionRequerida, setFormacionReq] = useState(undefined);
    const [formacionActual, setFormacionAct] = useState(undefined);
    const [especifico, setEspecifico] = useState(props.dataAPE.calificacionPruebaTecnica ?? undefined);
    const [competencias, setCompetencias] = useState(props.dataAPE.calificacionHabilidades ?? undefined);
    const [hseq, setHseq] = useState(props.dataAPE.calificacionHSEQ ?? undefined);
    const [calificacionJefe, setCalificacionJefe] = useState(props.dataAPE.calificacionEntrevista ?? undefined);
    const [calificacion, setCalificacion] = useState(((props.dataAPE.calificacionPruebaTecnica ?? 0) * 0.3 + (props.dataAPE.calificacionHabilidades ?? 0) * 0.15 + (props.dataAPE.calificacionEntrevista ?? 0) * 0.4 + (props.dataAPE.calificacionHSEQ ?? 0) * 0.15).toFixed(2));
    const [riesgo, setRiesgo] = useState('SIN NOVEDAD');
    const [observaciones, setObservaciones] = useState(undefined);
    const [tipoInforme, setTipoInforme] = useState('MOC');

    useEffect(() => {
    }, [])

    const getFinalValidation = () => {
        return (fecha !== undefined && fecha !== '' &&
            nombre !== undefined && nombre !== '' &&
            cargo !== undefined && cargo !== '' &&
            aspirante !== undefined && aspirante !== '' &&
            experienciaRequerida !== undefined && experienciaRequerida !== '' &&
            experienciaActual !== undefined && experienciaActual !== '' &&
            formacionRequerida !== undefined && formacionRequerida !== '' &&
            formacionActual !== undefined && formacionActual !== '' &&
            especifico !== undefined && especifico !== '' &&
            competencias !== undefined && competencias !== '' &&
            hseq !== undefined && hseq !== '' &&
            calificacionJefe !== undefined && calificacionJefe !== '' &&
            calificacion !== undefined && calificacion !== '' &&
            riesgo !== undefined && riesgo !== '' &&
            observaciones !== undefined && observaciones !== ''
        )
    }

    const handleDownload = async () => {
        props.setLoading(true)
        const body = {
            type: 'PDF',
            data: {
                creadoPor: userData.nombre ?? '',
                fecha: fecha ? fecha.toISOString().split('T')[0] : '',
                nombre: nombre ?? '',
                cargo: cargo ?? '',
                aspirante: aspirante ?? '',
                experienciaRequerida: experienciaRequerida ?? '',
                experienciaActual: experienciaActual ?? '',
                formacionRequerida: formacionRequerida ?? '',
                formacionActual: formacionActual ?? '',
                especifico: especifico ?? '',
                competencias: competencias ?? '',
                hseq: hseq ?? '',
                calificacionJefe: calificacionJefe ?? '',
                calificacion: calificacion ?? '',
                riesgo: riesgo ?? '',
                observaciones: observaciones ?? '',
            }
        }
        try {
            let downloadLink
            if (tipoInforme === 'MONC') { downloadLink = await apiExportarInformeFinalMONC(body) }
            else { downloadLink = await apiExportarInformeFinalMOC(body) }
            let downloadWindow = window.open(downloadLink, "_blank", "noopener,noreferrer")
            if (downloadWindow) downloadWindow.opener = null
            props.toggle()
            props.setLoading(false)
            props.toastSuccess('Contrato descargado!')
        }
        catch (e) {
            console.log('error', e)
            props.toastError('Hubo un error en la descarga')
        }
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Descargar'}
                onClick={() => { handleDownload() }}
                buttonLoading={!(getFinalValidation())}
                title={`Actualizar estado a `}
            >
                <Row>
                    <Col lg='2' md='2' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Tipo Informe</Label>
                        <Input
                            id="exampleSelect"
                            name="selectTipo"
                            type="select"
                            value={tipoInforme}
                            onChange={(e) => { setTipoInforme(e.target.value) }}
                        >
                            <option>
                                MOC
                            </option>
                            <option>
                                MONC
                            </option>
                        </Input>
                    </Col>
                    <Col lg='4' md='10' xs="10" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha</Label>
                        <Input
                            id="fecha"
                            name="datetime"
                            value={fecha ? fecha.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => setFecha(new Date(e.target.value))}
                            type="date"
                        />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Nombres y Apellidos</Label>
                        <Input type="text" name="text" id="inputNombre" defaultValue={nombre !== undefined ? nombre : ''} value={nombre} onChange={(e) => setNombre(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Cargo</Label>
                        <Input type="text" name="text" id="inputCargo" defaultValue={cargo !== undefined ? cargo : ''} value={cargo} onChange={(e) => setCargo(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Aspirante/Trabajador</Label>
                        <Input
                            id="exampleSelect"
                            name="selectTipo"
                            type="select"
                            value={aspirante}
                            onChange={(e) => { setAspirante(e.target.value) }}
                        >
                            <option>
                                ASPIRANTE
                            </option>
                            <option>
                                TRABAJADOR
                            </option>
                        </Input>
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Experiencia Requerida</Label>
                        <Input type="text" name="text" id="inputExpReq" defaultValue={experienciaRequerida !== undefined ? experienciaRequerida : ''} value={experienciaRequerida} onChange={(e) => setExperienciaReq(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Experiencia Actual</Label>
                        <Input type="text" name="text" id="inputExpAct" defaultValue={experienciaActual !== undefined ? experienciaActual : ''} value={experienciaActual} onChange={(e) => setExperienciaAct(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Formación Requerida</Label>
                        <Input type="text" name="text" id="inputForReq" defaultValue={formacionRequerida !== undefined ? formacionRequerida : ''} value={formacionRequerida} onChange={(e) => setFormacionReq(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Formación Actual</Label>
                        <Input type="text" name="text" id="inputForAct" defaultValue={formacionActual !== undefined ? formacionActual : ''} value={formacionActual} onChange={(e) => setFormacionAct(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Conocimiento Específico</Label>
                        <Input type="text" name="text" id="inputConEsp" defaultValue={especifico !== undefined ? especifico : ''} value={especifico} disabled />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">HSEQ</Label>
                        <Input type="text" name="text" id="inputHseq" defaultValue={hseq !== undefined ? hseq : ''} value={hseq} disabled />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Evaluación por Competencias</Label>
                        <Input type="text" name="text" id="inputComp" defaultValue={competencias !== undefined ? competencias : ''} value={competencias} disabled />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Entrevista Jefe Inmediato</Label>
                        <Input type="text" name="text" id="inputCalJefe" defaultValue={calificacionJefe !== undefined ? calificacionJefe : ''} value={calificacionJefe} disabled />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Calificación Obtenida</Label>
                        <Input type="text" name="text" id="inputCalificacion" defaultValue={calificacion !== undefined ? calificacion : ''} value={calificacion} disabled />
                    </Col>
                    <Col lg='6' md='12' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Riesgo</Label>
                        <Input
                            id="exampleSelect"
                            name="selectTipo"
                            type="select"
                            value={riesgo}
                            onChange={(e) => { setRiesgo(e.target.value) }}
                        >
                            <option>
                                SIN NOVEDAD
                            </option>
                            <option>
                                CON NOVEDAD
                            </option>
                        </Input>
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Observaciones</Label>
                        <Input type="text" name="text" id="inputObservaciones" defaultValue={observaciones !== undefined ? observaciones : ''} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalProcesoAprobado);